import { faSave } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useNotification from 'hooks/useNotification';
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import CurrencyInput from 'react-currency-input-field';
import ProductServiceService from 'services/ProductService.service';

const CatalogItemModal = ({
  showModal,
  handleClose,
  editingItem,
  onSuccess
}) => {
  const { showSuccessNotification, showErrorNotification } = useNotification();
  const [validated, setValidated] = useState(false);
  const initialState = {
    name: '',
    type: 'SERVICE',
    description: '',
    unitPrice: 0,
    inactive: false
  };
  const [body, setBody] = useState(initialState);
  const form = useRef(null);

  useEffect(() => {
    if (editingItem) {
      setBody({
        name: editingItem.name || '',
        type: editingItem.type || 'SERVICE',
        description: editingItem.description || '',
        unitPrice: editingItem.unitPrice || 0,
        inactive: editingItem.inactive || false
      });
    } else {
      setBody(initialState);
    }
    setValidated(false);
  }, [editingItem, showModal]);

  const onSubmit = async e => {
    e.preventDefault();

    if (form.current.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    const payload = {
      ...body,
      unitPrice: body.unitPrice
        ? parseFloat(String(body.unitPrice).replace(',', '.'))
        : 0
    };

    try {
      let response;
      if (editingItem) {
        response = await ProductServiceService.edit(editingItem.id, payload);
      } else {
        response = await ProductServiceService.create(payload);
      }

      if (response.userMessage) {
        showErrorNotification(response.userMessage);
        return;
      }

      showSuccessNotification(
        editingItem
          ? 'Produto/Serviço editado com sucesso'
          : 'Produto/Serviço criado com sucesso'
      );

      onSuccess();
    } catch (error) {
      showErrorNotification('Erro ao salvar produto/serviço');
    }
  };

  const required = <span className="text-danger">*</span>;

  return (
    <Modal show={showModal} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {editingItem ? 'Editar Produto/Serviço' : 'Novo Produto/Serviço'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form validated={validated} ref={form}>
          <Form.Group className="mb-3">
            <Form.Label>Nome {required}</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Nome do produto/serviço"
              value={body.name}
              onChange={e => setBody({ ...body, name: e.target.value })}
            />
            <Form.Control.Feedback type="invalid">
              Insira um nome.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tipo {required}</Form.Label>
            <Form.Select
              required
              value={body.type}
              onChange={e => setBody({ ...body, type: e.target.value })}
            >
              <option value="SERVICE">Serviço</option>
              <option value="PRODUCT">Produto</option>
            </Form.Select>
            <Form.Control.Feedback type="invalid">
              Selecione um tipo.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Descrição</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Descrição do produto/serviço"
              value={body.description}
              onChange={e => setBody({ ...body, description: e.target.value })}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Preço Unitário (R$) {required}</Form.Label>
            <CurrencyInput
              id="unitPrice"
              name="unitPrice"
              placeholder="R$ 0,00"
              value={body.unitPrice}
              decimalsLimit={2}
              onValueChange={value => setBody({ ...body, unitPrice: value })}
              prefix="R$ "
              className={`form-control ${
                validated && !body.unitPrice ? 'is-invalid' : ''
              }`}
              intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
            />
            <Form.Control.Feedback type="invalid">
              Insira um preço válido.
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Check
              type="switch"
              id="inactive-switch"
              label={body.inactive ? 'Inativo' : 'Ativo'}
              checked={!body.inactive}
              disabled={!editingItem}
              onChange={() => setBody({ ...body, inactive: !body.inactive })}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Fechar
        </Button>
        <Button variant="primary" onClick={onSubmit}>
          <FontAwesomeIcon icon={faSave} className="me-2" />
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CatalogItemModal;
